export default "__VITE_ASSET__d81f2d60__"